/*!
React-Swipeable
version 3.5.1 (modified by OutSystems)

Copyright (C) 2014-present Dogfessional

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/
define('OutSystems/ReactWidgets/Swipeable',["require", "exports", "tslib", "OutSystems/ClientRuntime/ObjectExtensions", "OutSystems/ReactView/HtmlTags", "prop-types", "react"], function (require, exports, tslib_1, ObjectExtensions, HtmlTags_1, PropTypes, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Swipeable = void 0;
    var Swipeable = (function (_super) {
        tslib_1.__extends(Swipeable, _super);
        function Swipeable(props) {
            var _this = _super.call(this, props) || this;
            _this.defaultState = {
                x: null,
                y: null,
                swiping: false,
                start: 0,
            };
            _this.calculatePos = function (e) {
                var x = e.changedTouches[0].clientX;
                var y = e.changedTouches[0].clientY;
                var xd = _this.state.x - x;
                var yd = _this.state.y - y;
                var axd = Math.abs(xd);
                var ayd = Math.abs(yd);
                return {
                    deltaX: xd,
                    deltaY: yd,
                    absX: axd,
                    absY: ayd,
                };
            };
            _this.touchStart = function (e) {
                if (e.touches.length > 1) {
                    return;
                }
                _this.setState({
                    start: Date.now(),
                    x: e.touches[0].clientX,
                    y: e.touches[0].clientY,
                    swiping: false,
                });
            };
            _this.touchMove = function (e) {
                if (!_this.state.x || !_this.state.y || e.touches.length > 1) {
                    return;
                }
                var cancelPageSwipe = false;
                var pos = _this.calculatePos(e);
                if (Math.abs(pos.deltaX) > Math.abs(pos.deltaY)) {
                    e.preventDefault();
                }
                if (pos.absX < _this.props.delta && pos.absY < _this.props.delta) {
                    return;
                }
                if (_this.props.onSwiping) {
                    _this.props.onSwiping(e, pos.deltaX, pos.deltaY, pos.absX, pos.absY);
                }
                if (pos.absX > pos.absY) {
                    if (pos.deltaX > 0) {
                        if (_this.props.onSwipingLeft) {
                            _this.props.onSwipingLeft(e, pos.absX, _this.state.x);
                            cancelPageSwipe = true;
                        }
                    }
                    else {
                        if (_this.props.onSwipingRight) {
                            _this.props.onSwipingRight(e, pos.absX, _this.state.x);
                            cancelPageSwipe = true;
                        }
                    }
                }
                else {
                    if (pos.deltaY > 0) {
                        if (_this.props.onSwipingUp) {
                            _this.props.onSwipingUp(e, pos.absY);
                            cancelPageSwipe = true;
                        }
                    }
                    else {
                        if (_this.props.onSwipingDown) {
                            _this.props.onSwipingDown(e, pos.absY);
                            cancelPageSwipe = true;
                        }
                    }
                }
                _this.setState({ swiping: true });
                if (cancelPageSwipe) {
                    e.preventDefault();
                }
            };
            _this.touchEnd = function (e) {
                if (_this.state.swiping) {
                    var pos = _this.calculatePos(e);
                    var time = Date.now() - _this.state.start;
                    var velocity = Math.sqrt(pos.absX * pos.absX + pos.absY * pos.absY) / time;
                    var isFlick = velocity > _this.props.flickThreshold;
                    if (_this.props.onSwiped) {
                        _this.props.onSwiped(e, pos.deltaX, pos.deltaY, isFlick);
                    }
                    if (pos.absX > pos.absY) {
                        if (pos.deltaX > 0) {
                            if (_this.props.onSwipedLeft) {
                                _this.props.onSwipedLeft(e, pos.deltaX, isFlick);
                            }
                        }
                        else {
                            if (_this.props.onSwipedRight) {
                                _this.props.onSwipedRight(e, pos.deltaX, isFlick);
                            }
                        }
                    }
                    else {
                        if (pos.deltaY > 0) {
                            if (_this.props.onSwipedUp) {
                                _this.props.onSwipedUp(e, pos.deltaY, isFlick);
                            }
                        }
                        else {
                            if (_this.props.onSwipedDown) {
                                _this.props.onSwipedDown(e, pos.deltaY, isFlick);
                            }
                        }
                    }
                }
                _this.setState(_this.defaultState);
            };
            _this.state = _this.defaultState;
            return _this;
        }
        Swipeable.prototype.render = function () {
            var newProps = ObjectExtensions.assign({}, this.props, {
                onTouchStart: this.touchStart,
                onTouchMove: this.touchMove,
                onTouchEnd: this.touchEnd,
            });
            delete newProps.onSwiped;
            delete newProps.onSwiping;
            delete newProps.onSwipingUp;
            delete newProps.onSwipingRight;
            delete newProps.onSwipingDown;
            delete newProps.onSwipingLeft;
            delete newProps.onSwipedUp;
            delete newProps.onSwipedRight;
            delete newProps.onSwipedDown;
            delete newProps.onSwipedLeft;
            delete newProps.flickThreshold;
            delete newProps.delta;
            return React.createElement(HtmlTags_1.HtmlTags.div, newProps, this.props.children);
        };
        Swipeable.propTypes = {
            onSwiped: PropTypes.func,
            onSwiping: PropTypes.func,
            onSwipingUp: PropTypes.func,
            onSwipingRight: PropTypes.func,
            onSwipingDown: PropTypes.func,
            onSwipingLeft: PropTypes.func,
            onSwipedUp: PropTypes.func,
            onSwipedRight: PropTypes.func,
            onSwipedDown: PropTypes.func,
            onSwipedLeft: PropTypes.func,
            flickthreshold: PropTypes.number,
            delta: PropTypes.number,
        };
        Swipeable.defaultProps = {
            flickthreshold: 0.6,
            delta: 10,
        };
        return Swipeable;
    }(React.Component));
    exports.Swipeable = Swipeable;
});
//# sourceMappingURL=Swipeable.js.map;
